import * as React from "react";
import ReactGA from "react-ga4";
import {useLocation} from "react-router-dom";

interface WrapperProps {
  children: React.PropsWithChildren<any>;
}

export default function GoogleAnalyticsWrapper(props: WrapperProps) {
  const location = useLocation();

  React.useEffect(() => {
    //console.log(`ReactGA.send pageview ${location.pathname}${location.search}`);
    ReactGA.send({hitType: "pageview", page: `${location.pathname}${location.search}`});
  }, [location]);

  return props.children;
}
